import { connect } from 'react-redux';

import * as actions from './actions';
import * as selectors from './selectors';

import ImpactChartView from './ImpactChartView';

const mapStateToProps = state => ({
    data: selectors.getData(state),
    timeLastUpdated: selectors.getTimeLastUpdated(state),
    fetching: selectors.getFetching(state),
    error: selectors.getError(state),
    useDollars: selectors.getUseDollars(state),
    sorting: selectors.getSorting(state)
});

const mapDispatchToProps = {
    initialised: actions.initialised,
    switchCurrencies: actions.switchCurrencies,
    setSorting: actions.setSorting,
    fetchImMonitoring: actions.fetchImMonitoringRequest,
    refreshData: actions.refreshData,
    refreshCsaChart: actions.refreshCsaChart
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImpactChartView);
